import eventLib from '@/common/utils/document-event';
import { removeCookie } from '@lhb/cache';
import { Message } from 'element-ui';
import store from '@/store/index';
import { isNotEmpty } from '@lhb/func';
// 清除localStorage除了指定key以外的所有值
var clearLocalStorage = function (filterKeys) {
    if (filterKeys === void 0) { filterKeys = []; }
    var filterValues = filterKeys.map(function (key) { return window.localStorage.getItem(key); });
    window.localStorage.clear();
    filterKeys.forEach(function (key, index) {
        isNotEmpty(filterValues[index]) && window.localStorage.setItem(key, filterValues[index]);
    });
};
export var clearUserInfo = function () {
    // 清除store中用户信息
    store.commit('RESET_MODULE_STATE');
    store.commit('RESET_STATE');
    // 保留首次进入地图模式引导图标识
    clearLocalStorage(['isNotFirstOpenRecommendation']);
    removeCookie('newPmsToken');
    removeCookie('placeIds');
    removeCookie('newPmsCompanyId');
    removeCookie('newPmsUserId');
    removeCookie('AdminToken');
    removeCookie('channel');
};
eventLib.on('LOGOUT', function (msg) {
    if (msg === void 0) { msg = '登录失败'; }
    // 这里使用route.push会导致页面样式错乱，需要调研具体原因
    window.location.href = '/login';
    clearUserInfo();
    msg && Message({
        message: msg,
        type: 'warning',
    });
});
